import { useEffect } from "react";
import { addtoRecent } from "../services/Spares";

const AddRecentlyViewed = ({ productid }) => {

  useEffect(() => {
    const addRecent = async () => {
      try {
        const userId = localStorage.getItem("userId");
        if (!userId || !productid) return;

        await addtoRecent({
          customerid: userId,
          productid: productid,
        });

      } catch (error) {
        console.error("Add to recent failed:", error);
      }
    };

    addRecent();
  }, [productid]);

  return null; 
};

export default AddRecentlyViewed;